<template>
  <div>
    <sdPageHeader :title="$t('pages.home.title')"> </sdPageHeader>
    <Main>
      <a-row :gutter="25" v-if="decoder($store.state.auth.is_root) == 1">
        <a-col :lg="6" :xs="24" v-for="(item, index) in adminBoxes" :key="index">
          <SimpleCardVue
            :text="item.text"
            :imgSrc="require('@/' + item.imgSrc)"
            :endpoint="item.endpoint"
          />
        </a-col>
      </a-row>
      <a-row v-else :gutter="25">
        <a-col :lg="8" :xs="24" v-for="(item, index) in developerBoxes" :key="index">
          <SimpleCardVue
            :text="item.text"
            :imgSrc="require('@/' + item.imgSrc)"
            :endpoint="item.endpoint"
          />
        </a-col>
      </a-row>

      <SaleStatisticsVue 
        :yTitle="$t('pages.home.sale-chart-ytitle')"
        :dataLabel="$t('pages.home.sale-chart-datalabel')"
        :mainTitle="$t('pages.home.sale-chart-main-title')"
        :endpoint="this.$endpoints.dashboard_sale_stats"
      />

      <a-row :gutter="25">
        <a-col :lg="12" :xs="24">
          <TopSellingCardVue 
            :cardTitle="$t('pages.home.table-sale-title')"
            :endpoint="this.$endpoints.dashboard_most_sale"
          />
        </a-col>
        <a-col :lg="12" :xs="24">
          <TopInstallsCardVue 
            :cardTitle="$t('pages.home.table-install-title')"
            :endpoint="this.$endpoints.dashboard_most_install"
          />
        </a-col>
      </a-row>
    </Main>
  </div>
</template>

<script>
import { Main } from '../styled';
import { defineAsyncComponent } from 'vue';
import SimpleCardVue from '@/components/cards/SimpleCard.vue';
import SaleStatisticsVue from './overview/SaleStatistics.vue';
import TopSellingCardVue from './overview/TopSellingCard.vue';
import TopInstallsCardVue from './overview/TopInstallsCard.vue';

const OverviewCard = defineAsyncComponent(() => import('./overview/OverviewCard'));
const ProfitCard = defineAsyncComponent(() => import('./overview/ProfitCard'));

export default {
  name: 'SocialMedia',
  components: {
    Main,
    OverviewCard,
    ProfitCard,
    SimpleCardVue,
    SaleStatisticsVue,
    TopSellingCardVue,
    TopInstallsCardVue
  },
  data() {
    return {
      adminBoxes: [
        {
          text: this.$t("pages.home.admin.app-total"),
          imgSrc: 'static/img/icon/smartphone.svg',
          endpoint: this.$endpoints.dashboard_total_app,
        },
        {
          text: this.$t("pages.home.admin.developer-total"),
          imgSrc: 'static/img/icon/user.svg',
          endpoint: this.$endpoints.dashboard_total_dev,
        },
        {
          text: this.$t("pages.home.admin.customer-total"),
          imgSrc: 'static/img/icon/NewCustomer.svg',
          endpoint: this.$endpoints.dashboard_total_user,
        },
        {
          text: this.$t("pages.home.admin.comment-total"),
          imgSrc: 'static/img/icon/message-circle.svg',
          endpoint: this.$endpoints.dashboard_total_rev,
        },
      ],
      developerBoxes: [
        {
          text: this.$t("pages.home.developer.app-total"),
          imgSrc: 'static/img/icon/smartphone.svg',
          endpoint: this.$endpoints.dashboard_total_app,
        },
        {
          text: this.$t("pages.home.developer.customer-total"),
          imgSrc: 'static/img/icon/NewCustomer.svg',
          endpoint: this.$endpoints.dashboard_total_user,
        },
        {
          text: this.$t("pages.home.developer.comment-total"),
          imgSrc: 'static/img/icon/message-circle.svg',
          endpoint: this.$endpoints.dashboard_total_rev,
        },
      ],
    };
  },
  methods: {
    decoder(value) {
      return atob(value);
    },
  },
  async setup() {},
};
</script>
